module.exports = "/build/web/images/sold_out.81661313e3f7faff31251fedf8c3a27e.png";


//////////////////
// WEBPACK FOOTER
// ./images/sold_out.png
// module id = 138
// module chunks = 24